"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var RequestData_1 = __importDefault(require("../../classes/RequestData"));
var event_bus_1 = require("../../event-bus");
var echo_1 = __importStar(require("../../echo"));
var request_1 = __importDefault(require("../../request"));
var DistrictsMixin = /** @class */ (function (_super) {
    __extends(DistrictsMixin, _super);
    function DistrictsMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.districts = new RequestData_1.default();
        return _this;
    }
    DistrictsMixin.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.district.create, this.onDistrictCreateEvent)
            .$on(event_bus_1.events.district.rename, this.onDistrictRenameEvent)
            .$on(event_bus_1.events.district.delete, this.onDistrictDeleteEvent);
        echo_1.default.channel(echo_1.channels.district)
            .listen(echo_1.events.district.create, this.requestDistricts)
            .listen(echo_1.events.district.rename, this.updateDistrict)
            .listen(echo_1.events.district.delete, this.requestDistricts);
    };
    DistrictsMixin.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.district.create, this.onDistrictCreateEvent)
            .$off(event_bus_1.events.district.rename, this.onDistrictRenameEvent)
            .$off(event_bus_1.events.district.delete, this.onDistrictDeleteEvent);
        echo_1.default.leave(echo_1.channels.district);
    };
    DistrictsMixin.prototype.requestDistricts = function (page) {
        return request_1.default.district.all(this.districts.search, page || this.districts.pagination.current_page, this.updateDistricts);
    };
    DistrictsMixin.prototype.requestDistrictsFirstPage = function () {
        return this.requestDistricts(1);
    };
    DistrictsMixin.prototype.onDistrictCreateEvent = function (district) {
        return request_1.default.district.create(district.name, this.requestDistricts);
    };
    DistrictsMixin.prototype.onDistrictRenameEvent = function (district) {
        return request_1.default.district.rename(district.id, district.name, this.updateDistrict);
    };
    DistrictsMixin.prototype.onDistrictDeleteEvent = function (district) {
        return request_1.default.district.delete(district.id, this.requestDistricts);
    };
    DistrictsMixin.prototype.onSearchPhraseInput = function (search) {
        this.updateSearchPhrase(search);
    };
    DistrictsMixin.prototype.updateDistricts = function (districts, pagination) {
        this.districts = this.districts
            .setArray(districts)
            .setPagination(pagination);
    };
    DistrictsMixin.prototype.updateDistrict = function (district) {
        this.districts = this.districts.updateArray(district);
    };
    DistrictsMixin.prototype.updateSearchPhrase = function (search) {
        this.districts = this.districts.setSearch(search);
    };
    DistrictsMixin = __decorate([
        vue_class_component_1.default
    ], DistrictsMixin);
    return DistrictsMixin;
}(vue_property_decorator_1.Vue));
exports.default = DistrictsMixin;
